import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from '../pages/Landing';
import PrivacyPolicy from '../pages/PrivacyPolicy';  // Página de Política de Privacidade
import TermsOfService from '../pages/TermsOfService';  // Página de Termos de Serviço

const AppStack = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Rota para a página principal */}
        <Route path='/' element={<Landing />} />
        
        {/* Rota para a página de Política de Privacidade */}
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />

        {/* Rota para a página de Termos de Serviço */}
        <Route path='/terms-of-service' element={<TermsOfService />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppStack;
